import logo from './pizza.png';
import pin from './pin.png';
import bg from './bg.jpg';
import './App.css';

function App() {
  return (
    <div className="App"> 
      <video autoPlay muted loop id="background-video" poster={bg}>
        <source src="./PizzaHD.mp4" type="video/mp4" />
      </video>
      <div className="overlay"></div>
      <img src={logo} className='logo' /> 
      <h1>ביחרו סניף</h1>
      <a className="button" href='https://kimathinamherzel.maxshop.co.il/'>
        <img src={pin} className='pin' />
        <div className="name">סניף הרצל</div>
        <span>כשר למהדרין בד"ץ בית יוסף</span>
      </a>
      <a className="button" href='https://kimathinamrama.maxshop.co.il/'>
        <img src={pin} className='pin' />
        <div className="name">סניף רמת בית שמש</div>
        <span>כשר למהדרין בד"ץ הרב אברהם רובין</span>      
      </a>
    </div>
  );
}

export default App;
